import { 
    ShareBaseDialog
} from 'sharebase/domain';

const template = require('./promptDialog.template');
export class PromptDialog extends ShareBaseDialog {
	public static $inject: string[] = [
		'$mdDialog',
		'SB_CHAR_LIMIT',
		'gettextCatalog'
	];

	// naming convention based on reserved characters for Windows:
	// https://msdn.microsoft.com/en-us/library/windows/desktop/aa365247(v=vs.85).aspx#naming_conventions
	// https://regex101.com/r/xK1gN6/4
	private regex = /^[^<>:"/\\|?*.]+([^<>:"/\\|?*](?=.))*[^<>:"/\\|?*.]*$/;
	private charLimit = this.SB_CHAR_LIMIT;
	private promptForm:ng.IFormController;
	private value:string = '';
	private placeholder:string;

	constructor(
		$mdDialog,
		private SB_CHAR_LIMIT:number,   
		private gettextCatalog:ng.gettext.gettextCatalog
	){
		super($mdDialog, template, '', false);
		this.setDefault();
	}

	public open(e:ng.IAngularEvent, title:string, placeholder?:string){
		this.setDefault();
		this.title = title;
		this.placeholder = placeholder;
		return super.open();
	}

	public dismiss(){
		if(this.promptForm.$valid){
			super.dismiss(this.value);
		}
	}

	private trim(){
		if(this.value){
			this.value.trim();
		}
	}

	/**
	 * Services in Angular are singletons, so any valuse from a previous use must be reset.
	 */
	private setDefault(){
		this.title = this.gettextCatalog.getString('Prompt');
		this.value = this.placeholder = '';
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/components/promptDialog/promptDialog.ts